export default __webpack_public_path__ + "static/media/external-link-alt.f4f77cac.svg";